<template>
    <grid-layout class="m-0">
        <grid-layout-item class="p-0">
            <slot
                name="header"
                :month="month"
                :prevMonth="prevMonth"
                :nextMonth="nextMonth"
                :currentMonth="currentMonth"
            >
                <div class="flex">
                    <button
                        type="button"
                        @click.prevent="prevMonth"
                    >
                        Prev
                    </button>

                    <div class="flex-grow text-center">
                        {{ month | moment('MMMM YYYY') }}
                    </div>

                    <button
                        type="button"
                        @click.prevent="nextMonth"
                    >
                        Next
                    </button>
                </div>
            </slot>
        </grid-layout-item>

        <grid-layout-item
            v-for="(weekday, index) in weekdays"
            :key="weekday"
            class="px-0 py-1 w-1/7"
        >
            <slot
                name="weekday"
                :weekday="weekday"
                :index="index"
            >
                {{ weekday }}
            </slot>
        </grid-layout-item>

        <grid-layout-item
            v-for="(date, index) in dates"
            :key="index"
            class="p-0 w-1/7"
        >
            <slot
                name="date"
                :date="date"
            >
                {{ date.date | moment('DD') }}
            </slot>
        </grid-layout-item>
    </grid-layout>
</template>

<script>
    import _ from 'lodash'
    import moment from 'moment'

    export default {
        props: {
            value: {
                type: Object,
                default: () => moment()
            },
            weekdays: {
                type: Array,
                default () {
                    return [
                        'Mon',
                        'Tue',
                        'Wed',
                        'Thu',
                        'Fri',
                        'Sat',
                        'Sun'
                    ]
                }
            }
        },
        data () {
            return {
                month: this.value
            }
        },
        computed: {
            dates () {
                let date = this.getFirstDay(this.month, this.first)

                // 42 = # days in 6 weeks
                let dates = _.range(42)
                    .map(i => {
                        date = date.clone().add(1, 'day')

                        return {
                            date,
                            is_today: date.isSame(moment(), 'day'),
                            is_current_month: date.isSame(this.month, 'month')
                        }
                    })

                // 35 = index of the first day of week 6
                if (!dates[35].is_current_month) {
                    dates = _.slice(dates, 0, 35)
                }

                return dates
            }
        },
        watch: {
            value () {
                if (this.value) {
                    this.month = this.value
                }
            },
            month () {
                this.$emit('input', this.month)
            }
        },
        methods: {
            currentMonth () {
                this.month = moment().startOf('month')
            },
            prevMonth () {
                this.month = moment(this.month).subtract(1, 'months').startOf('month')
            },
            nextMonth () {
                this.month = moment(this.month).add(1, 'months').startOf('month')
            },
            getFirstDay (date, first) {
                first = parseInt(first)

                const start = moment(date)
                const startOfMonth = moment(start.startOf('month'))

                start.subtract(startOfMonth.day(), 'days')

                if (startOfMonth.day() < first) {
                    start.subtract(7, 'days')
                }

                start.add(first, 'days')

                return start
            }
        }
    }
</script>
